<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div>
    <button type="button" class="btn-share" @click="openSnsPopup">공유</button>
<!--    <div class="icon-box share" @click="openSnsPopup">-->
<!--      <share-button></share-button>-->
<!--      <span class="icon-txt">공유</span>-->
<!--    </div>-->
    <portal to="info-popup" v-if="isOpenSnsSharePopup">
      <div class="info-popup-background"></div>
      <div class="info-popup-wrapper" @click.prevent="closeSnsPopup">
      <div class="sns-share-wrap">
        <ul class="sns-share-list">
          <li @click.prevent="openKakao">
            <button type="button" class="btn-share btn-share-kakao">
              <span>카카오톡</span>
            </button>
          </li>
          <li @click.prevent="openFacebook">
            <button type="button" class="btn-share btn-share-facebook">
              <span>페이스북</span>
            </button>
          </li>
          <li @click.prevent="openTwitter">
            <button type="button" class="btn-share btn-share-twitter">
              <span>트위터</span>
            </button>
          </li>
          <li v-clipboard:copy="url" v-clipboard:success="onCopy" v-clipboard:error="onError">
            <button type="button" class="btn-share btn-share-link">
              <span>링크 복사</span>
            </button>
          </li>
        </ul>
        <button type="button" class="btn-close-layer" @click.prevent="closeSnsPopup">레이어 닫기</button>

        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import SnsShareKaKaoIcon from '@/assets/svg/common/ic_player_share_kakao.svg'
import SnsShareFacebookIcon from '@/assets/svg/common/ic_player_share_facebook.svg'
import SnsShareTwittterIcon from '@/assets/svg/common/ic_player_share_twitter.svg'
import LinkCopyIcon from '@/assets/svg/common/ic_player_share_copy.svg'
import ShareButton from '@/assets/svg/common/ic_detail_share.svg'
import utils from '@/common/util/utils'
import { parse, stringify } from 'query-string'
import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'

export default {
  name: 'IconBoxSnsShare',
  components: {
    SnsShareKaKaoIcon,
    SnsShareFacebookIcon,
    SnsShareTwittterIcon,
    LinkCopyIcon,
    ShareButton
  },
  props: {
    contentInfo: {
      type: Object
    },
    section: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpenSnsSharePopup: false,
      url: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search,
      title: '',
      description: ''
    }
  },
  computed: {
    posterImage () {
      // poster image 우선순위 mo-)  1. 로고 포함된 시즌(무비 그룹) 가로 포스터 / 2. 로고가 포함된 시즌(무비 그룹) 세로 포스터
      const {
        season_horizontal_logoY_image: horizonPosterVOD = '',
        season_vertical_logoY_image: verticalPosterVOD = '',
        moviegroup_horizontal_logoY_image: horizonPosterMovie = '',
        moviegroup_vertical_logoY_image: verticalPosterMovie = ''
      } = this.contentInfo

      const { seasonposterimage: alternativePosterVOD = '' } = this.contentInfo
      const isMovie = (this.section === 'movie')
      const posterMovie = horizonPosterMovie || verticalPosterMovie
      const posterVOD = horizonPosterVOD || verticalPosterVOD || alternativePosterVOD

      return isMovie ? posterMovie : posterVOD
    }
  },
  methods: {
    prependProtocol (url) {
      if (url.indexOf('http:') > -1 || url.indexOf('https:') > -1) {
        return url
      } else {
        return `http://${url}`
      }
    },
    openSnsPopup () {
      disableBodyScroll()
      disablePageScroll(document.getElementsByTagName('body')[0])
      this.isOpenSnsSharePopup = true
    },
    closeSnsPopup () {
      enableBodyScroll()
      enablePageScroll(document.getElementsByTagName('body')[0])
      this.isOpenSnsSharePopup = false
    },
    openKakao () {
      let title = ''
      let description = ''
      let imageObj = {}
      switch (this.$route.params.section) {
        case 'vod':
          title = `[wavve]${this.contentInfo.programtitle}`
          description = `${this.contentInfo.episodenumber} 회 ${this.contentInfo.episodetitle}`
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 180
          break
        case 'live':
          title = `[wavve]${this.contentInfo.title}`
          description = ''
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 180
          break
        case 'clip':
          title = `[wavve]${this.contentInfo.programtitle}`
          description = this.contentInfo.cliptitle
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 180
          break
        case 'movie':
          title = `[wavve]${this.contentInfo.title}`
          description = ''
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 460
          break
      }

      /* eslint-disable */
      Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: title,
          description: description,
          imageUrl: imageObj.src,
          imageWidth: imageObj.width,
          imageHeight: imageObj.height,
          link: {
            mobileWebUrl: this.url,
            webUrl: this.url
          }
        },
        buttons: [
          {
            title: '자세히 보기',
            link: {
              mobileWebUrl: this.url,
              webUrl: this.url
            }
          }
        ],
        installTalk: true
      })
    },
    openFacebook () {
      let title, description
      let imageObj = {}
      switch (this.$route.params.section) {
        case 'vod':
          title = `[wavve]${this.contentInfo.programtitle}`
          description = `${this.contentInfo.episodenumber} 회 ${this.contentInfo.episodetitle}`
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 180
          break
        case 'live':
          title = `[wavve]${this.contentInfo.title}`
          description = ''
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 180
          break
        case 'clip':
          title = `[wavve]${this.contentInfo.programtitle}`
          description = this.contentInfo.cliptitle
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 180
          break
        case 'movie':
          title = `[wavve]${this.contentInfo.title}`
          description = ''
          imageObj.src = this.prependProtocol(this.posterImage)
          imageObj.width = 320
          imageObj.height = 460
          break
      }

      FB.ui({
          method: 'share_open_graph',
          action_type: 'og.shares',
          action_properties: JSON.stringify({
            object: {
              'og:url': this.url,
              'og:title': title,
              'og:image': imageObj.src,
              'og:description': description,
            }
          })
        },
        function (response) {
        });

      return false;
    },
    openTwitter() {
      let title, description
      switch (this.$route.params.section) {
        case 'vod':
          title = `[wavve]${this.contentInfo.programtitle}`
          description = `${this.contentInfo.episodenumber}회 ${this.contentInfo.episodetitle}`
          break
        case 'live':
          title = `[wavve]${this.contentInfo.channelname} ${this.contentInfo.title}`
          description = ''
          break
        case 'clip':
          title = `[wavve]${this.contentInfo.programtitle}`
          description = this.contentInfo.cliptitle
          break
        case 'movie':
          title = `[wavve]${this.contentInfo.title}`
          description = ''
          break
      }
      const popup = window.open('https://twitter.com/share?text=' + title + '%0a'
        + description + '%0a&url='
        + encodeURIComponent(this.url), '트위터 공유', 'width=626,height=436');
      popup.window.focus();
    },
    onCopy() {
      this.$toast({ message: '링크를 복사했어요.' })
    },
    onError() {
      this.$toast({ message: '복사 실패' })
    },
  },
  created () {
    const query = parse(window.location.search)
    delete query.referer
    delete query.search
    this.url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + stringify(query)
  },
  beforeCreate () {
    window.kakaoAsyncInit = function() {
      Kakao.init('30fc7e17b5c56a0ca1e861643292c203');
    };
    utils.common.setLibFile(document, 'script', 'kakao-jssdk', '//developers.kakao.com/sdk/js/kakao.min.js');
    window.fbAsyncInit = function() {
      FB.init({
        appId: '1818575348440201',
        status: true,
        cookie: true, // 쿠키가 세션을 참조할 수 있도록 허용
        xfbml: true, // 소셜 플러그인이 있으면 처리
        version: 'v4.0' // 버전 4.0 사용
      })
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/ko_KR/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

}
</script>
